import entityData from './entityData.json';

// Export the entity types from the JSON data
export const ANIMAL_TYPES = entityData.ANIMAL_TYPES;
export const PLANT_TYPES = entityData.PLANT_TYPES;

export function getAnimalType(id) {
    return Object.values(ANIMAL_TYPES).find(type => type.id === id);
}

export function getPlantType(id) {
    return Object.values(PLANT_TYPES).find(type => type.id === id);
} 